// hooks/usePageTrack.ts
import { useEffect, useRef } from 'react';
import { Mixpanel } from '@/lib/mixpanel';

type Props = Record<string, unknown>;

export const usePageTrack = (pageKey: string, props: Props = {}) => {
  const lastKey = useRef<string | null>(null);

  useEffect(() => {
    if (!pageKey) return;
    if (lastKey.current === pageKey) return;

    Mixpanel.track('Page Visited', {
      date: new Date().toISOString(),
      pageKey,
      ...props,
    });

    lastKey.current = pageKey;
  }, [pageKey]); // only depends on pageKey
};
